export default class HandledPromiseRejectionError extends Error {
  constructor(message = "An error occured in the application") {
    super(message);
  }
}
